import { useState } from "react";
import { useInstallPrompt } from "../hooks/useInstallPrompt";
import "./InstallButton.css";

export default function InstallButton() {
  const { status, install } = useInstallPrompt();
  const [iosTipOpen, setIosTipOpen] = useState(false);

  if (status === "installed") return null;

  if (status === "available") {
    return (
      <button
        className="button install-button"
        onClick={() => install()}
        title="Install this app on your device"
      >
        📲 Install app
      </button>
    );
  }

  if (status === "ios") {
    return (
      <>
        <button
          className="button secondary install-button"
          onClick={() => setIosTipOpen((v) => !v)}
        >
          📲 Add to Home Screen
        </button>
        {iosTipOpen && (
          <div className="install-tip">
            On iPhone: tap the <strong>Share</strong> button (square with ↑ at the
            bottom of Safari), then scroll down and tap <strong>Add to Home
            Screen</strong>. The app icon will appear on your home screen.
          </div>
        )}
      </>
    );
  }

  // status === "unsupported" — don't show anything in the header to avoid clutter,
  // but the option will appear automatically once the browser deems it installable.
  return null;
}
